import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as buttons from "../../tokens/buttons";
import { fonts, fontBreakpoint } from "../../tokens/fonts2022";
var fontStyleWithResetLineheight = function fontStyleWithResetLineheight(key) {
  var styles = _objectSpread({}, fonts[key]);
  styles.lineHeight = "1";
  styles[fontBreakpoint] = _objectSpread({}, styles[fontBreakpoint]);
  delete styles[fontBreakpoint].lineHeight;
  return styles;
};
var sizeVariations = {
  small: {
    height: "32px",
    padding: "0 var(--CDS-spacing-m)",
    span: _objectSpread({}, fontStyleWithResetLineheight("heading-xxxs"))
  },
  medium: {
    height: "44px",
    padding: "0 24px",
    span: _objectSpread({}, fontStyleWithResetLineheight("heading-xxs"))
  },
  large: {
    height: "48px",
    padding: "0 32px",
    span: _objectSpread({}, fontStyleWithResetLineheight("heading-xs"))
  },
  xl: {
    height: "56px",
    padding: "0 32px",
    span: _objectSpread({}, fontStyleWithResetLineheight("heading-s"))
  }
};
export function createStyles(_ref) {
  var appearance = _ref.appearance,
    size = _ref.size,
    stretch = _ref.stretch,
    squared = _ref.squared,
    iconOnly = _ref.iconOnly;
  var states = buttons[appearance === "default" ? "defaultState" : appearance];
  return _objectSpread(_objectSpread(_objectSpread({
    background: states.background,
    color: states.color,
    border: "1px solid ".concat(states.border),
    boxShadow: "none",
    cursor: "pointer",
    transition: "none",
    margin: 0,
    position: "relative",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    overflow: "visible",
    textTransform: "none",
    userSelect: "none",
    whiteSpace: "nowrap",
    alignItems: "center",
    justifyContent: "center",
    width: stretch && "100%",
    display: stretch ? "flex" : "inline-flex",
    borderRadius: squared ? "var(--CDS-border-radius-s)" : "var(--CDS-border-radius-full)"
  }, sizeVariations[size]), iconOnly ? {
    padding: "0px",
    width: sizeVariations[size].height
  } : {}), {}, {
    "&:focus": {
      background: states.background,
      borderColor: states.border,
      color: states.color
    },
    "&:focus-visible": {
      zIndex: 1,
      outline: "2px solid var(--CDS-color-semantic-actions-default)",
      outlineOffset: "2px"
    },
    "&:visited": {
      color: states.color,
      background: states.background
    },
    "&:hover": {
      background: states.hover.background,
      borderColor: states.hover.border,
      color: states.hover.color
    },
    "&:active": {
      background: states.active.background,
      borderColor: states.active.border,
      color: states.active.color,
      boxShadow: "0 0 0 1px ".concat(states.active.border, " inset")
    },
    "&[disabled], &[disabled]:hover, &[disabled]:active": {
      boxShadow: "none",
      opacity: 1,
      color: states.disabled.color,
      background: states.disabled.background,
      borderColor: states.disabled.border,
      cursor: "not-allowed"
    }
  });
}